import { cidadeService } from '../_services/';

export const cidadeAction = {
    getCidadesSelect
};

function getCidadesSelect(id_estado) {
    return dispatch => {
        let apiEndpoint = 'cidades/select/' + id_estado;
        cidadeService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Text: 'SELECIONE...', Value: '' })
                dispatch(changeCidadesList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}
export function changeCidadesList(cidade) {
    return {
        type: "FETECHED_ALL_CIDADE",
        cidade: cidade
    }
}
export function editCidadesDetails(cidade) {
    return {
        type: "CIDADE_DETAIL",
        id: cidade.id,
        nome: cidade.nome,
        data_exclusao: cidade.data_exclusao,
        usuario_exclusao: cidade.usuario_exclusao,
        ibge: cidade.ibge,
        id_estado: cidade.id_estado
    }
}